import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "@/layout/index.vue"

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: '登录',
    hidden: true,
    component: () => import('@/views/login/index')
  },
  {
    path: '/bigScreen',
    component: () => import('@/views/bigScreen/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true
  },
  {
    path: '/detail',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'productInfo',
        component: () => import('@/views/product/list/info'),
        name: 'ProductDetail',
        meta: { title: '产品详情' }
      },
       {
        path: 'updatePwd',
        component: () => import('@/views/updatePwd/index'),
        name: 'updatePwd',
        meta: { title: '修改密码' }
      },
      {
        path: 'orderInfo',
        component: () => import('@/views/order/product/info'),
        name: 'OrderProductDetail',
        meta: { title: '订单详情' }
      },
      {
        path: 'userInfo',
        component: () => import('@/views/user/list/info'),
        name: 'UserProductDetail',
        meta: { title: '用户详情' }
      },
      {
        path: 'shopInfo',
        component: () => import('@/views/shop/offline/info'),
        name: 'OfflineShopDetail',
        meta: { title: '店铺详情' }
      },
      {
        path: 'institutionConfig',
        component: () => import('@/views/system/institution/config.vue'),
        name: 'InstitutionConfig',
        meta: { title: '机构配置' }
      },
      {
        path: 'storeAddress',
        component: () => import('@/views/shop/offline/storeAddress'),
        name: 'OfflineStoreAddress',
        meta: { title: '店铺地址' }
      },
      {
        path: 'shop/group',
        component: () => import('@/views/shop/offline/group'),
        name: 'shopGroup',
        meta: { title: '店铺团购套餐' }
      },
      {
        path: 'shop/group/info',
        component: () => import('@/views/shop/offline/group/info'),
        name: 'shopGroupInfo',
        meta: { title: '店铺团购套餐详情' }
      },
      {
        path: 'shop/commodity',
        component: () => import('@/views/shop/offline/commodity'),
        name: 'shopCommodity',
        meta: { title: '店铺商品' }
      },
      {
        path: 'shop/classification',
        component: () => import('@/views/shop/offline/classification'),
        name: 'shopClassification',
        meta: { title: '店铺商品分类' }
      },
      {
        path: 'entry/info',
        component: () => import('@/views/statistics/entryLog/info'),
        name: 'entryLogDetail',
        meta: { title: '入驻详情' }
      },
    ]
  }
]

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [
  
]

// 公共路由
export const constantRoutes  = routes

document.title = '蓉曜数创'
// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

export default new VueRouter({
  // mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
